import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <LandingPage />
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
